import { fromEvent, startWith, map, distinctUntilChanged, switchMap, catchError, EMPTY } from 'rxjs';

import { showError } from './ui.js';
import { createCollectionsView } from './collections-view.js';
import { createCollectionView } from './collection-view.js';
import { createSectionView } from './section-view.js';
import { createImportView } from './import-view.js';
import { createDestructCollectionView } from './destruct-collection-view.js';
import { createDocumentView } from './document-view.js';
import { createCollectionDocumentsView } from './collection-documents-view.js';
import { createCollectionApiKeysView } from './collection-api-keys-view.js';
import { createCollectionSharingView } from './collection-sharing-view.js';
import { createAcceptInviteView } from './accept-invite-view.js';
import { createSimilarSectionsView } from './similar-sections-view.js';

let routePath$ = fromEvent(window, 'hashchange').pipe(
    startWith(undefined),
    map(() => {
        let hash = window.location.hash || '';
        if (hash.startsWith('#')) {
            hash = hash.substring(1);
        }
        return hash.trim();
    }),
    distinctUntilChanged(),
);

let view$ = routePath$.pipe(
    map(path => {
        if (path === '') {
            return createCollectionsView();
        } else if (path.startsWith('collection/')) {
            let fragments = path.split('/');
            let colId = parseInt(fragments[1]);
            if (fragments.length === 3 && path.endsWith('/destruct')) {
                return createDestructCollectionView(colId);
            } else if (fragments.length === 3 && path.endsWith('/documents')) {
                return createCollectionDocumentsView(colId);
            } else if (fragments.length === 3 && path.endsWith('/api-keys')) {
                return createCollectionApiKeysView(colId);
            } else if (fragments.length === 3 && path.endsWith('/sharing')) {
                return createCollectionSharingView(colId);
            } else if(fragments.length === 2) {
                return createCollectionView(colId);
            }
        } else if (path.startsWith('accept/')) {
            let token = path.substring('accept/'.length);
            return createAcceptInviteView(token);
        } else if (path.startsWith('section/')) {
            let secId = parseInt(path.substring('section/'.length));
            return createSectionView(secId);
        } else if (path.startsWith('document/')) {
            let docId = parseInt(path.substring('document/'.length));
            return createDocumentView(docId);
        } else if (path === 'import') {
            return createImportView();
        } else if (path === 'search') {
            return createSimilarSectionsView();
        } else {
            window.location.href = '#';
            console.warn(`Unknown route: ${path}`);
            return createCollectionsView();
        }
    }),
);

view$.pipe(
    switchMap(view$ => view$),
    catchError(err => {
        showError(err);
        return EMPTY;
    }),
).subscribe();

